module.exports = __webpack_public_path__ + "static/media/white-close.db4b755d.svg";